"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Ftestapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestApiServiceClient = exports.taskRunOutcomeToJSON = exports.taskRunOutcomeFromJSON = exports.SimulateTokenExpiredResponse = exports.SimulateTokenExpiredRequest = exports.LoginAsResponse = exports.LoginAsRequest = exports.AddTaskRunResponse = exports.AddTaskRunRequest = exports.AssignCampaignResponse = exports.AssignCampaignRequest = exports.CloseAccountResponse = exports.CloseAccountRequest = exports.GetAllFeaturesResponse = exports.GetAllFeaturesRequest = exports.EnableFeatureResponse = exports.EnableFeatureRequest = exports.UnlinkAliasResponse = exports.UnlinkAliasRequest = exports.UnlinkSandboxPlaidAccountResponse = exports.UnlinkSandboxPlaidAccountRequest = exports.TestAdminLoginResponse = exports.TestAdminLoginRequest = exports.EchoResponse = exports.EchoRequest = exports.UpdateTransactionResponse = exports.UpdateTransactionRequest = exports.SuspendUserResponse = exports.SuspendUserRequest = exports.GetVirtualAccountStatusResponse = exports.GetVirtualAccountStatusRequest = exports.CreateVirtualAccountSimulationResponse = exports.CreateVirtualAccountSimulationRequest = exports.RejectedTransfer = exports.TestVirtualAccountTransfer = exports.CloseFundingDisputeResponse = exports.CloseFundingDisputeRequest = exports.ReverseFundingTransactionResponse = exports.ReverseFundingTransactionRequest = exports.GetChargeIdResponse = exports.GetChargeIdRequest = exports.LoadFundsResponse = exports.LoadFundsRequest = exports.TaskRunOutcome = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const ach_account_1 = require("../common/ach-account");
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const external_card_1 = require("../common/external-card");
const step_user_group_1 = require("../common/step-user-group");
const token_1 = require("../common/token");
const feature_1 = require("../feature/feature");
const transaction_status_1 = require("../ledger/transaction-status");
const protobufPackage = 'com.step.testapi.proto';
var TaskRunOutcome;
(function (TaskRunOutcome) {
    TaskRunOutcome["INVALID_STATUS"] = "INVALID_STATUS";
    TaskRunOutcome["COMPLETED"] = "COMPLETED";
    TaskRunOutcome["ERROR"] = "ERROR";
    TaskRunOutcome["FAILED"] = "FAILED";
    TaskRunOutcome["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TaskRunOutcome || (exports.TaskRunOutcome = TaskRunOutcome = {}));
function createBaseLoadFundsRequest() {
    return { accountId: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.LoadFundsRequest = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.LoadFundsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoadFundsRequest();
        message.accountId = object.accountId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseLoadFundsResponse() {
    return {};
}
exports.LoadFundsResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.LoadFundsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseLoadFundsResponse();
        return message;
    },
};
function createBaseGetChargeIdRequest() {
    return { paymentId: '' };
}
exports.GetChargeIdRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargeIdRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargeIdRequest();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseGetChargeIdResponse() {
    return { chargeId: '' };
}
exports.GetChargeIdResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.chargeId)) {
            message.chargeId = globalThis.String(object.chargeId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.chargeId !== undefined && message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargeIdResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargeIdResponse();
        message.chargeId = object.chargeId ?? '';
        return message;
    },
};
function createBaseReverseFundingTransactionRequest() {
    return { userId: '', fundingSourceId: '', externalTransactionId: '' };
}
exports.ReverseFundingTransactionRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            fundingSourceId: isSet(object.fundingSourceId)
                ? globalThis.String(object.fundingSourceId)
                : '',
            externalTransactionId: isSet(object.externalTransactionId)
                ? globalThis.String(object.externalTransactionId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.fundingSourceId !== '') {
            obj.fundingSourceId = message.fundingSourceId;
        }
        if (message.externalTransactionId !== '') {
            obj.externalTransactionId = message.externalTransactionId;
        }
        return obj;
    },
    create(base) {
        return exports.ReverseFundingTransactionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReverseFundingTransactionRequest();
        message.userId = object.userId ?? '';
        message.fundingSourceId = object.fundingSourceId ?? '';
        message.externalTransactionId = object.externalTransactionId ?? '';
        return message;
    },
};
function createBaseReverseFundingTransactionResponse() {
    return {};
}
exports.ReverseFundingTransactionResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ReverseFundingTransactionResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseReverseFundingTransactionResponse();
        return message;
    },
};
function createBaseCloseFundingDisputeRequest() {
    return {
        provider: external_card_1.ExternalCardProvider.INVALID_PROVIDER,
        externalTransactionId: '',
        disputeWon: false,
    };
}
exports.CloseFundingDisputeRequest = {
    fromJSON(object) {
        const message = {
            provider: isSet(object.provider)
                ? (0, external_card_1.externalCardProviderFromJSON)(object.provider)
                : external_card_1.ExternalCardProvider.INVALID_PROVIDER,
            externalTransactionId: isSet(object.externalTransactionId)
                ? globalThis.String(object.externalTransactionId)
                : '',
        };
        if (isSet(object.disputeWon)) {
            message.disputeWon = globalThis.Boolean(object.disputeWon);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.provider !== external_card_1.ExternalCardProvider.INVALID_PROVIDER) {
            obj.provider = (0, external_card_1.externalCardProviderToJSON)(message.provider);
        }
        if (message.externalTransactionId !== '') {
            obj.externalTransactionId = message.externalTransactionId;
        }
        if (message.disputeWon !== undefined && message.disputeWon !== false) {
            obj.disputeWon = message.disputeWon;
        }
        return obj;
    },
    create(base) {
        return exports.CloseFundingDisputeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseFundingDisputeRequest();
        message.provider = object.provider ?? external_card_1.ExternalCardProvider.INVALID_PROVIDER;
        message.externalTransactionId = object.externalTransactionId ?? '';
        message.disputeWon = object.disputeWon ?? false;
        return message;
    },
};
function createBaseCloseFundingDisputeResponse() {
    return {};
}
exports.CloseFundingDisputeResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CloseFundingDisputeResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCloseFundingDisputeResponse();
        return message;
    },
};
function createBaseTestVirtualAccountTransfer() {
    return {
        id: '',
        accountNumber: '',
        routingNumber: '',
        accountType: ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
        amount: amount_1.Amount.fromPartial({}),
        effectiveDate: undefined,
        description: '',
    };
}
exports.TestVirtualAccountTransfer = {
    fromJSON(object) {
        const message = {
            accountNumber: isSet(object.accountNumber) ? globalThis.String(object.accountNumber) : '',
            routingNumber: isSet(object.routingNumber) ? globalThis.String(object.routingNumber) : '',
            accountType: isSet(object.accountType)
                ? (0, ach_account_1.achAccountTypeFromJSON)(object.accountType)
                : ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.id)) {
            message.id = globalThis.String(object.id);
        }
        if (isSet(object.effectiveDate)) {
            message.effectiveDate = date_1.LocalDate.fromJSON(object.effectiveDate);
        }
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== undefined && message.id !== '') {
            obj.id = message.id;
        }
        if (message.accountNumber !== '') {
            obj.accountNumber = message.accountNumber;
        }
        if (message.routingNumber !== '') {
            obj.routingNumber = message.routingNumber;
        }
        if (message.accountType !== ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE) {
            obj.accountType = (0, ach_account_1.achAccountTypeToJSON)(message.accountType);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = date_1.LocalDate.toJSON(message.effectiveDate);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.TestVirtualAccountTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestVirtualAccountTransfer();
        message.id = object.id ?? '';
        message.accountNumber = object.accountNumber ?? '';
        message.routingNumber = object.routingNumber ?? '';
        message.accountType = object.accountType ?? ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.effectiveDate = (object.effectiveDate !== undefined && object.effectiveDate !== null)
            ? date_1.LocalDate.fromPartial(object.effectiveDate)
            : undefined;
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseRejectedTransfer() {
    return { id: '', errorCode: '' };
}
exports.RejectedTransfer = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            errorCode: isSet(object.errorCode) ? globalThis.String(object.errorCode) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.errorCode !== '') {
            obj.errorCode = message.errorCode;
        }
        return obj;
    },
    create(base) {
        return exports.RejectedTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRejectedTransfer();
        message.id = object.id ?? '';
        message.errorCode = object.errorCode ?? '';
        return message;
    },
};
function createBaseCreateVirtualAccountSimulationRequest() {
    return { transfers: [] };
}
exports.CreateVirtualAccountSimulationRequest = {
    fromJSON(object) {
        const message = {
            transfers: globalThis.Array.isArray(object?.transfers)
                ? object.transfers.map((e) => exports.TestVirtualAccountTransfer.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transfers?.length) {
            obj.transfers = message.transfers.map((e) => exports.TestVirtualAccountTransfer.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CreateVirtualAccountSimulationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateVirtualAccountSimulationRequest();
        message.transfers = object.transfers?.map((e) => exports.TestVirtualAccountTransfer.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseCreateVirtualAccountSimulationResponse() {
    return { state: '' };
}
exports.CreateVirtualAccountSimulationResponse = {
    fromJSON(object) {
        const message = {
            state: isSet(object.state) ? globalThis.String(object.state) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== '') {
            obj.state = message.state;
        }
        return obj;
    },
    create(base) {
        return exports.CreateVirtualAccountSimulationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateVirtualAccountSimulationResponse();
        message.state = object.state ?? '';
        return message;
    },
};
function createBaseGetVirtualAccountStatusRequest() {
    return { state: '' };
}
exports.GetVirtualAccountStatusRequest = {
    fromJSON(object) {
        const message = {
            state: isSet(object.state) ? globalThis.String(object.state) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== '') {
            obj.state = message.state;
        }
        return obj;
    },
    create(base) {
        return exports.GetVirtualAccountStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetVirtualAccountStatusRequest();
        message.state = object.state ?? '';
        return message;
    },
};
function createBaseGetVirtualAccountStatusResponse() {
    return { complete: false, rejectedTransfers: [] };
}
exports.GetVirtualAccountStatusResponse = {
    fromJSON(object) {
        const message = {
            complete: isSet(object.complete) ? globalThis.Boolean(object.complete) : false,
            rejectedTransfers: globalThis.Array.isArray(object?.rejectedTransfers)
                ? object.rejectedTransfers.map((e) => exports.RejectedTransfer.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.complete !== false) {
            obj.complete = message.complete;
        }
        if (message.rejectedTransfers?.length) {
            obj.rejectedTransfers = message.rejectedTransfers.map((e) => exports.RejectedTransfer.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetVirtualAccountStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetVirtualAccountStatusResponse();
        message.complete = object.complete ?? false;
        message.rejectedTransfers =
            object.rejectedTransfers?.map((e) => exports.RejectedTransfer.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSuspendUserRequest() {
    return { userId: '' };
}
exports.SuspendUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.SuspendUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSuspendUserRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseSuspendUserResponse() {
    return {};
}
exports.SuspendUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SuspendUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSuspendUserResponse();
        return message;
    },
};
function createBaseUpdateTransactionRequest() {
    return { paymentId: '', transactionId: '', status: transaction_status_1.TransactionStatus.PENDING };
}
exports.UpdateTransactionRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            status: isSet(object.status)
                ? (0, transaction_status_1.transactionStatusFromJSON)(object.status)
                : transaction_status_1.TransactionStatus.PENDING,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.status !== transaction_status_1.TransactionStatus.PENDING) {
            obj.status = (0, transaction_status_1.transactionStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateTransactionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTransactionRequest();
        message.paymentId = object.paymentId ?? '';
        message.transactionId = object.transactionId ?? '';
        message.status = object.status ?? transaction_status_1.TransactionStatus.PENDING;
        return message;
    },
};
function createBaseUpdateTransactionResponse() {
    return {};
}
exports.UpdateTransactionResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateTransactionResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateTransactionResponse();
        return message;
    },
};
function createBaseEchoRequest() {
    return { delayMs: '0', status: '', message: '' };
}
exports.EchoRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.delayMs)) {
            message.delayMs = globalThis.String(object.delayMs);
        }
        if (isSet(object.status)) {
            message.status = globalThis.String(object.status);
        }
        if (isSet(object.message)) {
            message.message = globalThis.String(object.message);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.delayMs !== undefined && message.delayMs !== '0') {
            obj.delayMs = message.delayMs;
        }
        if (message.status !== undefined && message.status !== '') {
            obj.status = message.status;
        }
        if (message.message !== undefined && message.message !== '') {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.EchoRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEchoRequest();
        message.delayMs = object.delayMs ?? '0';
        message.status = object.status ?? '';
        message.message = object.message ?? '';
        return message;
    },
};
function createBaseEchoResponse() {
    return { message: '', traceId: '', remoteIp: '', requestId: '' };
}
exports.EchoResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.message)) {
            message.message = globalThis.String(object.message);
        }
        if (isSet(object.traceId)) {
            message.traceId = globalThis.String(object.traceId);
        }
        if (isSet(object.remoteIp)) {
            message.remoteIp = globalThis.String(object.remoteIp);
        }
        if (isSet(object.requestId)) {
            message.requestId = globalThis.String(object.requestId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined && message.message !== '') {
            obj.message = message.message;
        }
        if (message.traceId !== undefined && message.traceId !== '') {
            obj.traceId = message.traceId;
        }
        if (message.remoteIp !== undefined && message.remoteIp !== '') {
            obj.remoteIp = message.remoteIp;
        }
        if (message.requestId !== undefined && message.requestId !== '') {
            obj.requestId = message.requestId;
        }
        return obj;
    },
    create(base) {
        return exports.EchoResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEchoResponse();
        message.message = object.message ?? '';
        message.traceId = object.traceId ?? '';
        message.remoteIp = object.remoteIp ?? '';
        message.requestId = object.requestId ?? '';
        return message;
    },
};
function createBaseTestAdminLoginRequest() {
    return { ttlMs: '0', groups: [], gcloudJwt: '' };
}
exports.TestAdminLoginRequest = {
    fromJSON(object) {
        const message = {
            groups: globalThis.Array.isArray(object?.groups)
                ? object.groups.map((e) => (0, step_user_group_1.stepUserGroupFromJSON)(e))
                : [],
        };
        if (isSet(object.ttlMs)) {
            message.ttlMs = globalThis.String(object.ttlMs);
        }
        if (isSet(object.gcloudJwt)) {
            message.gcloudJwt = globalThis.String(object.gcloudJwt);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ttlMs !== undefined && message.ttlMs !== '0') {
            obj.ttlMs = message.ttlMs;
        }
        if (message.groups?.length) {
            obj.groups = message.groups.map((e) => (0, step_user_group_1.stepUserGroupToJSON)(e));
        }
        if (message.gcloudJwt !== undefined && message.gcloudJwt !== '') {
            obj.gcloudJwt = message.gcloudJwt;
        }
        return obj;
    },
    create(base) {
        return exports.TestAdminLoginRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestAdminLoginRequest();
        message.ttlMs = object.ttlMs ?? '0';
        message.groups = object.groups?.map((e) => e) || [];
        message.gcloudJwt = object.gcloudJwt ?? '';
        return message;
    },
};
function createBaseTestAdminLoginResponse() {
    return {
        userId: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
    };
}
exports.TestAdminLoginResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.TestAdminLoginResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestAdminLoginResponse();
        message.userId = object.userId ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseUnlinkSandboxPlaidAccountRequest() {
    return { userId: '', externalAccountId: '' };
}
exports.UnlinkSandboxPlaidAccountRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.UnlinkSandboxPlaidAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnlinkSandboxPlaidAccountRequest();
        message.userId = object.userId ?? '';
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseUnlinkSandboxPlaidAccountResponse() {
    return {};
}
exports.UnlinkSandboxPlaidAccountResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UnlinkSandboxPlaidAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUnlinkSandboxPlaidAccountResponse();
        return message;
    },
};
function createBaseUnlinkAliasRequest() {
    return { alias: alias_1.Alias.fromPartial({}) };
}
exports.UnlinkAliasRequest = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.UnlinkAliasRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnlinkAliasRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        return message;
    },
};
function createBaseUnlinkAliasResponse() {
    return {};
}
exports.UnlinkAliasResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UnlinkAliasResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUnlinkAliasResponse();
        return message;
    },
};
function createBaseEnableFeatureRequest() {
    return { userId: '', feature: feature_1.Feature.INVALID_FEATURE, variantName: '' };
}
exports.EnableFeatureRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            feature: isSet(object.feature) ? (0, feature_1.featureFromJSON)(object.feature) : feature_1.Feature.INVALID_FEATURE,
        };
        if (isSet(object.variantName)) {
            message.variantName = globalThis.String(object.variantName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.feature !== feature_1.Feature.INVALID_FEATURE) {
            obj.feature = (0, feature_1.featureToJSON)(message.feature);
        }
        if (message.variantName !== undefined && message.variantName !== '') {
            obj.variantName = message.variantName;
        }
        return obj;
    },
    create(base) {
        return exports.EnableFeatureRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnableFeatureRequest();
        message.userId = object.userId ?? '';
        message.feature = object.feature ?? feature_1.Feature.INVALID_FEATURE;
        message.variantName = object.variantName ?? '';
        return message;
    },
};
function createBaseEnableFeatureResponse() {
    return {};
}
exports.EnableFeatureResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnableFeatureResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnableFeatureResponse();
        return message;
    },
};
function createBaseGetAllFeaturesRequest() {
    return {};
}
exports.GetAllFeaturesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAllFeaturesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetAllFeaturesRequest();
        return message;
    },
};
function createBaseGetAllFeaturesResponse() {
    return { features: [] };
}
exports.GetAllFeaturesResponse = {
    fromJSON(object) {
        const message = {
            features: globalThis.Array.isArray(object?.features)
                ? object.features.map((e) => feature_1.FeatureInfo.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.features?.length) {
            obj.features = message.features.map((e) => feature_1.FeatureInfo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAllFeaturesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAllFeaturesResponse();
        message.features = object.features?.map((e) => feature_1.FeatureInfo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCloseAccountRequest() {
    return { primaryAccountId: '', userId: '' };
}
exports.CloseAccountRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.CloseAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseAccountRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseCloseAccountResponse() {
    return {};
}
exports.CloseAccountResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CloseAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCloseAccountResponse();
        return message;
    },
};
function createBaseAssignCampaignRequest() {
    return { userId: '', campaign: '' };
}
exports.AssignCampaignRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            campaign: isSet(object.campaign) ? globalThis.String(object.campaign) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        return obj;
    },
    create(base) {
        return exports.AssignCampaignRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssignCampaignRequest();
        message.userId = object.userId ?? '';
        message.campaign = object.campaign ?? '';
        return message;
    },
};
function createBaseAssignCampaignResponse() {
    return {};
}
exports.AssignCampaignResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AssignCampaignResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAssignCampaignResponse();
        return message;
    },
};
function createBaseAddTaskRunRequest() {
    return { name: '', id: '', outcome: TaskRunOutcome.INVALID_STATUS, delayMs: '0' };
}
exports.AddTaskRunRequest = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            outcome: isSet(object.outcome)
                ? taskRunOutcomeFromJSON(object.outcome)
                : TaskRunOutcome.INVALID_STATUS,
            delayMs: isSet(object.delayMs) ? globalThis.String(object.delayMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.outcome !== TaskRunOutcome.INVALID_STATUS) {
            obj.outcome = taskRunOutcomeToJSON(message.outcome);
        }
        if (message.delayMs !== '0') {
            obj.delayMs = message.delayMs;
        }
        return obj;
    },
    create(base) {
        return exports.AddTaskRunRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddTaskRunRequest();
        message.name = object.name ?? '';
        message.id = object.id ?? '';
        message.outcome = object.outcome ?? TaskRunOutcome.INVALID_STATUS;
        message.delayMs = object.delayMs ?? '0';
        return message;
    },
};
function createBaseAddTaskRunResponse() {
    return {};
}
exports.AddTaskRunResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddTaskRunResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddTaskRunResponse();
        return message;
    },
};
function createBaseLoginAsRequest() {
    return { userId: '' };
}
exports.LoginAsRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.LoginAsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoginAsRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseLoginAsResponse() {
    return { refreshToken: token_1.AuthToken.fromPartial({}), accessToken: token_1.AuthToken.fromPartial({}) };
}
exports.LoginAsResponse = {
    fromJSON(object) {
        const message = {
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.LoginAsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoginAsResponse();
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseSimulateTokenExpiredRequest() {
    return {};
}
exports.SimulateTokenExpiredRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SimulateTokenExpiredRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSimulateTokenExpiredRequest();
        return message;
    },
};
function createBaseSimulateTokenExpiredResponse() {
    return {};
}
exports.SimulateTokenExpiredResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SimulateTokenExpiredResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSimulateTokenExpiredResponse();
        return message;
    },
};
function taskRunOutcomeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STATUS':
            return TaskRunOutcome.INVALID_STATUS;
        case 2:
        case 'COMPLETED':
            return TaskRunOutcome.COMPLETED;
        case 3:
        case 'ERROR':
            return TaskRunOutcome.ERROR;
        case 4:
        case 'FAILED':
            return TaskRunOutcome.FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TaskRunOutcome.UNRECOGNIZED;
    }
}
exports.taskRunOutcomeFromJSON = taskRunOutcomeFromJSON;
function taskRunOutcomeToJSON(object) {
    switch (object) {
        case TaskRunOutcome.INVALID_STATUS:
            return 'INVALID_STATUS';
        case TaskRunOutcome.COMPLETED:
            return 'COMPLETED';
        case TaskRunOutcome.ERROR:
            return 'ERROR';
        case TaskRunOutcome.FAILED:
            return 'FAILED';
        case TaskRunOutcome.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.taskRunOutcomeToJSON = taskRunOutcomeToJSON;
/**
 * Test API Service.
 *
 * Used to simulate transactions, load money into account, etc.
 */
class TestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.TestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'LoadFunds',
            requestType: exports.LoadFundsRequest,
            responseType: exports.LoadFundsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'ReverseFundingTransaction',
            requestType: exports.ReverseFundingTransactionRequest,
            responseType: exports.ReverseFundingTransactionResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetChargeId',
            requestType: exports.GetChargeIdRequest,
            responseType: exports.GetChargeIdResponse,
            authenticationOptions: undefined,
        }, {
            name: 'AssignCampaign',
            requestType: exports.AssignCampaignRequest,
            responseType: exports.AssignCampaignResponse,
            authenticationOptions: undefined,
        }, {
            name: 'CloseFundingDispute',
            requestType: exports.CloseFundingDisputeRequest,
            responseType: exports.CloseFundingDisputeResponse,
            authenticationOptions: undefined,
        }, {
            name: 'CreateVirtualAccountSimulation',
            requestType: exports.CreateVirtualAccountSimulationRequest,
            responseType: exports.CreateVirtualAccountSimulationResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetVirtualAccountStatus',
            requestType: exports.GetVirtualAccountStatusRequest,
            responseType: exports.GetVirtualAccountStatusResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SuspendUser',
            requestType: exports.SuspendUserRequest,
            responseType: exports.SuspendUserResponse,
            authenticationOptions: undefined,
        }, {
            name: 'UpdateTransaction',
            requestType: exports.UpdateTransactionRequest,
            responseType: exports.UpdateTransactionResponse,
            authenticationOptions: undefined,
        }, {
            name: 'Echo',
            requestType: exports.EchoRequest,
            responseType: exports.EchoResponse,
            authenticationOptions: undefined,
        }, {
            name: 'Login',
            requestType: exports.TestAdminLoginRequest,
            responseType: exports.TestAdminLoginResponse,
            authenticationOptions: undefined,
        }, {
            name: 'UnlinkSandboxPlaidAccount',
            requestType: exports.UnlinkSandboxPlaidAccountRequest,
            responseType: exports.UnlinkSandboxPlaidAccountResponse,
            authenticationOptions: undefined,
        }, {
            name: 'UnlinkAlias',
            requestType: exports.UnlinkAliasRequest,
            responseType: exports.UnlinkAliasResponse,
            authenticationOptions: undefined,
        }, {
            name: 'EnableFeature',
            requestType: exports.EnableFeatureRequest,
            responseType: exports.EnableFeatureResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetAllFeatures',
            requestType: exports.GetAllFeaturesRequest,
            responseType: exports.GetAllFeaturesResponse,
            authenticationOptions: undefined,
        }, {
            name: 'CloseAccount',
            requestType: exports.CloseAccountRequest,
            responseType: exports.CloseAccountResponse,
            authenticationOptions: undefined,
        }, {
            name: 'AddTaskRun',
            requestType: exports.AddTaskRunRequest,
            responseType: exports.AddTaskRunResponse,
            authenticationOptions: undefined,
        }, {
            name: 'LoginAs',
            requestType: exports.LoginAsRequest,
            responseType: exports.LoginAsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateTokenExpired',
            requestType: exports.SimulateTokenExpiredRequest,
            responseType: exports.SimulateTokenExpiredResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Loads funds into an account.
     */
    loadFunds(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Reverses the given transaction.
     */
    reverseFundingTransaction(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets the charge id from the transaction id
     */
    getChargeId(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Assign referral campaign
     */
    assignCampaign(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Closes a pending dispute for a card funding transaction.
     */
    closeFundingDispute(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates receipt of a Virtual Account JSON file with the given transfers.
     */
    createVirtualAccountSimulation(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns status of a Virtual Account transfer simulation.
     */
    getVirtualAccountStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Suspend the user.
     */
    suspendUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates the status of a pending transaction.
     */
    updateTransaction(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Echo request/response to be used for testing. Useful for testing service availability.
     */
    echo(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Create and login a random user with ADMIN rights.
     * Must only be used by Admin-Web tests.
     */
    login(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Unlinks the given sandbox Plaid account. Also triggers a LOGIN_REQUIRED webhook.
     */
    unlinkSandboxPlaidAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Unlink alias from the specified user.
     */
    unlinkAlias(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[12],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Enable the specified feature for the user.
     */
    enableFeature(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[13],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get all available features for the user.
     */
    getAllFeatures(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[14],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Closes the existing account for the specified user.
     */
    closeAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[15],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Add task run to taskqueue table.
     */
    addTaskRun(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[16],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Generates a token pair that can be used to login as the given user.
     */
    loginAs(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[17],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a token expired request by always returning 401 TOKEN_EXPIRED.
     */
    simulateTokenExpired(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[18],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.TestApiServiceClient = TestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=testapi-service.js.map